<template>
	<div>
		<!-- <common-tab :list="tabList" :index="tabId + 1"></common-tab> -->
		<div class="tab">
			<div
				class="tab-item"
				:class="{ isActive: item.index === tabIndex }"
				v-for="item in tabList"
				:key="item.index"
				@click="tabClick(item.index)"
			>
				{{ item.title }}
			</div>
		</div>
		<div id="introduce" v-if="tabIndex == 1">
			<div class="word-container" v-if="item != undefined">
				<div class="all">
					<div class="title">{{ item.name }}</div>
					<div class="content" v-html="item.content"></div>
				</div>
			</div>

			<div v-else class="withoutContent">暂无园区</div>
		</div>
		<!-- <div v-if="tabId == 2">
			<announcement :tabId="tabId"></announcement>
		</div> -->
		<div v-if="tabIndex == 2">
			<business></business>
		</div>
		<!-- <div v-if="tabId == 4">
			<company :tabId="tabId"></company>
		</div> -->
	</div>
</template>

<script>
// import CommonTab from "@/components/CommonTab.vue"
// import Announcement from './Announcement.vue'
import Business from "./Business.vue"
// import Company from './Company.vue'
import { mapGetters } from "vuex"

export default {
	components: {
		// commonTab: CommonTab,
		// announcement: Announcement,
		business: Business
		// company: Company,
	},
	data() {
		return {
			item: "",
			tabList: [
				{ title: "园区详情", index: 1 },
				{ title: "园区商户", index: 2 }
			]
		}
	},

	computed: {
		...mapGetters(["token", "userId", "tabIndex"])
	},
	watch: {
		communityId() {
			this.getData()
		}
	},

	mounted() {
		console.log(1111111)
		this.getData()
	},

	methods: {
		getData() {
			this.vaxios.get(
				`${this.vaxios.host}/open/api/v1/introductions/community/${this.$route.query.communityId}`,
				{},
				(res) => {
					if (res === -1 || !res.data) return
					this.item = res.data
					this.item.contentCount = this.getSimpleText(res.data.content)
				},
				function (err) {
					console.log(err)
				},
				{
					headers: {
						Authorization: "Bearer " + this.token,
						"Content-Type": "application/json"
					}
				}
			)
		},
		tabClick(index) {
			// this.tabId = index
			this.$store.commit("changeTabIndex", index)
		},
		// 富文本的字数
		//html剔除富文本标签，留下纯文本
		getSimpleText(html) {
			var re1 = new RegExp("<.+?>|&nbsp;", "g") //匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
			var msg = html.replace(re1, "") //执行替换成空字符
			return msg.length
		}
	}
}
</script>

<style scoped>
.word-container {
	padding: 0 1rem 0 1rem;
}

.tab {
	height: 44px;
	font-size: 0.9375rem;
	display: flex;
}

.tab .tab-item {
	padding: 0 4px;
	color: #646566;
	flex: 1;
	text-align: center;
	line-height: 44px;
	position: relative;
}

.tab .tab-item.isActive {
	color: #1592e6;
	font-weight: 500;
}

.tab .tab-item.isActive::after {
	content: "";
	width: 20%;
	height: 3px;
	background: #409eff;
	position: absolute;
	bottom: 0;
	left: 50%;
	transform: translateX(-50%);
}

.title {
	margin-top: 1.25rem;
	font-size: 1.375rem;
	font-weight: bold;
}

.word-counter {
	color: #5c5c5c;
	width: 100%;
	text-align: right;
}

.content {
	margin-top: 2.53125rem;
	color: #272727;
	font-size: 1rem;
	padding-bottom: 30px;
}

.content img {
	display: block;
	width: 100%;
	height: 100%;
}

.withoutContent {
	margin-top: 20%;
	display: flex;
	justify-content: center;
}
.content /deep/ img {
	width: 100% !important;
}
</style>
